import {
  types,
  FieldNames,
  IFormFields,
  IModalOpenAction,
  IModalCloseAction,
  ISetFieldValueAction,
  ISetFormErrorsAction,
  IClearFormErrorsAction,
  IPublishScheduleFormErrors,
  IScheduleRequestStart,
  IScheduleRequestFinish,
  IGetSchedules,
  IGetSchedulesSuccess,
  IGetSchedulesFailure,
  IScheduleRecord,
  IDeleteModalCloseAction,
  IDeleteModalOpenAction,
} from '../types/publishSchedule'

export const setFieldValue = (fieldName: FieldNames, value: any): ISetFieldValueAction => ({
  type: types.SET_FIELD_VALUE,
  fieldName,
  value,
})

export const setFormErrors = (fieldErrors: IPublishScheduleFormErrors): ISetFormErrorsAction => ({
  type: types.SET_FORM_ERRORS,
  fieldErrors,
})

export const clearFormErrors = (): IClearFormErrorsAction => ({
  type: types.CLEAR_FORM_ERRORS,
})

export const scheduleModalOpen = (
  defaultFieldValues?: Partial<IFormFields>,
  currentScheduleId?: string
): IModalOpenAction => ({
  type: types.SCHEDULE_MODAL_OPEN,
  currentScheduleId: !!currentScheduleId ? currentScheduleId : undefined,
  defaultFieldValues,
})

export const scheduleModalClose = (): IModalCloseAction => ({
  type: types.SCHEDULE_MODAL_CLOSE,
})

export const deleteScheduleModalOpen = (currentScheduleId: string): IDeleteModalOpenAction => ({
  type: types.SCHEDULE_DELETE_MODAL_OPEN,
  currentScheduleId,
})

export const deleteScheduleModalClose = (): IDeleteModalCloseAction => ({
  type: types.SCHEDULE_DELETE_MODAL_CLOSE,
})

export const scheduleRequestStart = (): IScheduleRequestStart => ({
  type: types.SCHEDULE_REQUEST__START,
})

export const scheduleRequestFinish = (): IScheduleRequestFinish => ({
  type: types.SCHEDULE_REQUEST__FINISH,
})

export const getSchedules = (): IGetSchedules => ({
  type: types.GET_SCHEDULES,
})

export const getSchedulesSuccess = (schedules: IScheduleRecord[]): IGetSchedulesSuccess => ({
  type: types.GET_SCHEDULES__SUCCESS,
  schedules,
})

export const getSchedulesFailure = (): IGetSchedulesFailure => ({
  type: types.GET_SCHEDULES__FAILURE,
})
